<template>
  <div class="divDesign">
    <!-- <nav-bar :onIndex="4"></nav-bar> -->
    <DetailsNav></DetailsNav>
    <div class="content">
      <div class="" v-if="bannerInfo">
        <div
          class="banner"
          :style="{
            'background-color': bannerInfo.bannerColor,
            'background-image': `url(${bannerInfo.bannerBgImg[0].url})`,
          }"
        >
          <div class="bannerBox">
            <div class="leftCont">
              <div class="bannerLogo">
                <div class="colFont">
                  <img
                    v-if="bannerInfo.logo && bannerInfo.logo.length > 0"
                    :src="bannerInfo.logo[0].url"
                    height="90px"
                  />
                </div>
              </div>
              <div class="bannerdesc">
                <banner-desc :data="strToArr(bannerInfo.objectIntroduction)"></banner-desc>
              </div>
              <div class="actionCont" v-if="bannerInfo.videoUrl">
                <div class="button" @click="handleVideo(bannerInfo.videoUrl)" >
                  <span class="anim"></span>
                  <img src="./img/icon015.png" width="22px" alt="" />
                  观看导学视频
                </div>
                <div class="buttonRt" @click="lookBigImage(bannerInfo.bannerBgImg[1].url)" >
                  <img src="./img/product_rt.png" width="23px" alt="" />
                  查看教学作品
                </div>
              </div>
              <div class="actionCont" v-else>
                <div class="button" @click="lookBigImage(bannerInfo.bannerBgImg[1].url)" >
                  <span class="anim"></span>
                  <img src="./img/product.png" width="23px" alt="" />
                  查看教学作品
                </div>
              </div>
            </div>
            <div class="rightCont">
              <div class="subjectflowTitle">
                <div class="divNav">
                  <span
                    @click="
                      () => {
                        $router.push('/');
                      }
                    "
                    class="spanSubject"
                    >首页 /
                  </span>
                  <span
                    @click="
                      () => {
                        $router.push('/ui');
                      }
                    "
                    class="spanSubject"
                    >设计</span
                  >
                  <span class="spanSplit"> / </span>
                  <span class="spanName">{{ bannerInfo.title }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bannerInfo">
          <div class="infoContBox">
            <div class="infoCard">
              <span class="industryLogo">
                <img
                  v-if="
                    bannerInfo.contListDataes &&
                    bannerInfo.contListDataes.length > 0
                  "
                  :src="bannerInfo.contListDataes[0].image[0].url"
                />
              </span>
              {{ bannerInfo.contListDataes[0].title }}
            </div>
            <div
              class="infoCard"
              v-if="
                bannerInfo.contListDataes && bannerInfo.contListDataes.length >= 4
              "
            >
              <ul>
                <li
                  v-for="(item, index) in bannerInfo.contListDataes.slice(1, 4)"
                  :key="index"
                >
                  <span class="icon iconCon"></span>
                  {{ item.title }}：<span class="num">{{
                    index == 0 ? numberA : index == 1 ? numberB : numberC
                  }}</span>
                </li>
              </ul>
            </div>
           </div>
        </div>
      </div>
      <!-- 第二屏 -->
      <div
        id="scrollTg1"
        class="design"
        :class="{ scrollTg1Show: scrollTg1Show }"
        v-if="bannerInfo && designProject"
      >
        <design-module
          :bannerInfo="bannerInfo"
          :designProject="designProject"
          :subject="subject"
        ></design-module>
      </div>
      <!-- end -->
      <!-- <flow-widge
        v-if="navshow"
        :flowData="flowData"
        :baseHeight="baseHeight"
        :localItemIndex="localItemIndex"
        class="web_scroll"
      ></flow-widge> -->
      <div class="divOffsetParent" v-if="itemAdvantage">
        <!-- 第三屏 -->
        <div
          id="scrollTg2"
          class="vs"
          :class="{ scrollTg2Show: scrollTg2Show }"
        >
          <production-module
            :itemAdvantage="itemAdvantage"
            :subject="subject"
          ></production-module>
        </div>
        <!--  -->
        <!-- 作品 -->
        <div
          id="scrollTg8"
          class="production"
          :class="{ scrollTg8Show: scrollTg8Show }"
        >
          <students-work-module
            :production="production"
            :studentsInfo="studentsInfo"
            @statentsShowHandle="statentsShowHandle"
            @showBigImghandle="showBigImghandle"
          ></students-work-module>
        </div>
        <!-- end -->
        <!-- 技能 -->
        <div
          id="scrollTg5"
          class="skill"
          :class="{ scrollTg5Show: scrollTg5Show }"
        >
          <skill-module :technology="technology"></skill-module>
        </div>
        <!-- end -->
        <!-- 项目去掉 -->
        <!-- <div
          id="scrollTg4"
          class="goodProject"
          :class="{ scrollTg4Show: scrollTg4Show }"
        >
          <project-module :resultsShow="resultsShow"></project-module>
        </div> -->
        <!-- end -->

        <!-- 架构 -->
        <div
          id="scrollTg6"
          class="framework"
          :class="{ scrollTg6Show: scrollTg6Show }"
        >
          <framework-module :framework="framework"></framework-module>
        </div>
        <!-- end -->
        <!-- 经验 -->
        <div
          id="scrollTg7"
          class="experience"
          :class="{ scrollTg7Show: scrollTg7Show }"
        >
          <learning-module
            :learning="learning"
            :listData="listData"
            @handleClick="handleClick"
          ></learning-module>
        </div>
        <!-- end -->

        <!-- 老师 -->
        <div
          id="scrollTg9"
          class="lecturer"
          :class="{ scrollTg9Show: scrollTg9Show }"
        >
          <teacher-module
            :strength="strength"
            :teachersInfo="teachersInfo"
            :teachersList="teachersList"
            @teachShowHandle="teachShowHandle"
          ></teacher-module>
        </div>
        <!-- end -->
        <!-- 适合学员 -->
        <div
          id="scrollTg3"
          class="study"
          :class="{ scrollTg3Show: scrollTg3Show }"
        >
          <student-module :suitableStudents="suitableStudents"></student-module>
        </div>
      </div>
    </div>

    <MenuAdd ref="editMenu"></MenuAdd>
    <!-- <project-module
      :biggerImgPreview="biggerImgPreview"
      :showBigImageUrl="showBigImageUrl"
      @closeImg="closeImg"
    ></project-module> -->
    <el-dialog
      :visible.sync="biggerImgPreview"
      :before-close="closeImg"
      :close="closeImg"
      class="bigImgDialog"
      style="margin-top: 3vh"
      append-to-body
    >
      <div class="DesClose" @click="closeImg">
        <img src="./img/close.png" width="28px" alt="" />
      </div>
      <div style="overflow: hidden">
        <div style="overflow-y: scroll; height: 93vh">
          <img v-if="showBigImageUrl" :src="showBigImageUrl" width="100%" />
        </div>
      </div>
    </el-dialog>
    <bottom-widge></bottom-widge>
  </div>
</template>
<script>
import bannerDesc from "./../../../components/bannerDesc.vue";
import { uiObject } from "../../../../gqlapi/UiObject.js";
import DetailsNav from "./../../../components/detailsNav.vue";
import MenuAdd from "./../../../components/video";
import bottomWidge from "@/views/components/bottomWidge";
import { statusTabsAddEventListener } from "./../../../js/tools";
// 组件
import designModule from "./components/designModule"; //
import studentModule from "./components/studentModule"; //适合学员
import productionModule from "./components/productionModule"; //
import skillModule from "./components/skillModule"; //技能
import frameworkModule from "./components/frameworkModule"; //架构
import learningModule from "./components/learningModule"; //学习路线
import studentsWorkModule from "./components/studentsWorkModule"; //学员作品
import teacherModule from "./components/teacherModule"; //师资力量
export default {
  components: {
    DetailsNav,
    bannerDesc,
    MenuAdd,
    bottomWidge,
    designModule,
    studentModule,
    productionModule,
    skillModule,
    frameworkModule,
    learningModule,
    studentsWorkModule,
    teacherModule,
  },
  data() {
    return {
      flowData: [],
      baseHeight: 0,
      localItemIndex: 0,
      oldHeight: 0,
      scrollFlag: {
        top: true,
        bottom: true,
      },
      tableData: [],
      logo: "",
      banner: "",
      baseInfo:{
        baseInfoTitle1: '',
        baseInfoTitle2: '',
        baseInfoDesc1: '',
        baseInfoDesc2: '',
        pVideoUrl: '',
        videoLogoImage: ''
      },
      baseData: {},
      activeIndex: 0,
      listData: [],
      showBigImageUrl: "",
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 25,
        slidesPerGroup: 2,
        allowTouchMove: false,
        loop: false,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          disabledClass: "swiper-button-disabled-class",
        },
      },
      biggerImgPreview: false,
      studentsWorksList: [],
      studentsInfo: {},
      teachersList: [],
      teachersInfo: {},
      teachersIndex: 0,
      navshow: false,
      scrollClass: {
        pInit: "parent web_scroll",
        pChange: "parent web_scroll  p-change",
        cInit: "ul-init",
        cChange: "",
      },
      itemAdvantage: {},
      suitableStudents: {},
      resultsShow: {},
      technology: {},
      framework: {},
      learning: {},
      production: {},
      strength: {},
      playUrl: "",

      bannerInfo: {
        contListDataes: [],
      },
      numberA: null,
      numberB: null,
      numberC: null,
      timerNum: { numberA: null, numberB: null, numberC: null },
      scrollTg1Show: true,
      scrollTg2Show: false,
      scrollTg3Show: false,
      scrollTg4Show: false,
      scrollTg5Show: false,
      scrollTg6Show: false,
      scrollTg7Show: false,
      scrollTg8Show: false,
      scrollTg9Show: false,
      visible: false,
      designProject: {},
      subject: {},
      videoUrl: "",
      bannerDeSt: false,
    };
  },
  watch: {
    listData(arr) {
      setTimeout(() => {
        statusTabsAddEventListener(document, arr.length);
      }, 1000);
    },
  },
  created() {
    this.detailId = sessionStorage.getItem("detailsId");
    this.getData(this.detailId);
  },
  mounted() {
    window.addEventListener("scroll", this.scrollHandle);
    Object.freeze(this.scrollFlag);
    Object.freeze(this.scrollClass);
    Object.freeze(this.oldHeight);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollHandle);
  },
  methods: {
    scrollHandle() {
      this.handleNavScroll();
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 显示马上学习导航
      scrollTop >= 1800 ? (this.navshow = true) : (this.navshow = false);
      let tag2 = document.querySelector("#scrollTg2");
      let tag3 = document.querySelector("#scrollTg3");
      let tag5 = document.querySelector("#scrollTg5");
      let tag6 = document.querySelector("#scrollTg6");
      let tag7 = document.querySelector("#scrollTg7");
      let tag8 = document.querySelector("#scrollTg8");
      let tag9 = document.querySelector("#scrollTg9");
      if (scrollTop >= tag2.offsetTop - 850) {
        this.scrollTg2Show = true;
      }
      if (scrollTop >= tag8.offsetTop - 850) {
        this.scrollTg8Show = true;
      }
      if (scrollTop >= tag5.offsetTop - 850) {
        this.scrollTg5Show = true;
      }
      if (scrollTop >= tag6.offsetTop - 850) {
        this.scrollTg6Show = true;
      }
      if (scrollTop >= tag7.offsetTop - 850) {
        this.scrollTg7Show = true;
      }
      if (scrollTop >= tag9.offsetTop - 850) {
        this.scrollTg9Show = true;
      }
      if (scrollTop >= tag3.offsetTop - 850) {
        this.scrollTg3Show = true;
      }
      // if (scrollTop >= tag4.offsetTop - 850) {
      //   this.scrollTg4Show = true;
      // }
    },
    handleNavScroll() {
      let oldHeight = this.oldHeight;
      let localHeight =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      let scrollHeight = this.baseHeight;
      let eles = document.querySelector(".divOffsetParent").children;
      for (let index in eles) {
        if (localHeight > eles[index].offsetTop + scrollHeight - 10) {
          this.localItemIndex = Number(index);
        }
      }
      let scrollFlag = this.scrollFlag;
      let scrollClass = this.scrollClass;
      if (oldHeight > localHeight) {
        //向上
        if (scrollFlag.top && localHeight < scrollHeight) {
          scrollFlag.top = false;
          scrollFlag.bottom = true;
          let parent = document.querySelector(".web_scroll");
          let child = parent.children[0];
          parent.className = scrollClass.pInit;
          child.className = scrollClass.cInit;
        }
      } else {
        //向下
        if (scrollFlag.bottom && localHeight > scrollHeight) {
          scrollFlag.top = true;
          scrollFlag.bottom = false;
          let parent = document.querySelector(".web_scroll");
          if (parent !== null) {
            let child = parent.children[0];
            parent.className = scrollClass.pChange;
            child.className = scrollClass.cChange;
          }
        }
      }
      this.oldHeight = localHeight;
    },
    // 获取详情
    getData(detailId) {
      this.$axios
        .post("/api", {
          operationName: "uiObject",
          variables: {
            id: detailId,
          },
          query: uiObject,
        })
        .then((res) => {
          const data = res.data.data;
          console.log(data);
          this.baseData = data.uiObject;
          this.getFlowData(data.uiObject);
          // 为什么要学电商店铺运营设计项目
          this.designProject = this.baseData.UiModuleA[0];
          this.bannerInfo = {
            logo: this.baseData.logo,
            title: this.baseData.title,
            videoUrl: this.baseData.videoUrl,
            contListDataes: this.baseData.bannerLabels,
            objectIntroduction: this.baseData.desc,
            videoBackground: this.baseData.titleImage,
            bannerColor: this.baseData.BannerColor,
            bannerBgImg: this.baseData.banenrImage,
          };
          // this.bannerInfo.contListDataes = bannerData;
          this.dataCount(
            "numberA",
            0,
            this.baseData.bannerLabels[1].about,
            20,
            1
          );
          this.dataCount(
            "numberB",
            0,
            this.baseData.bannerLabels[2].about,
            5,
            1
          );
          this.dataCount(
            "numberC",
            0,
            this.baseData.bannerLabels[3].about,
            25,
            1
          );
          //所有软件
          let classDate = this.baseData.classLists;
          classDate.forEach((val) => {
            val.desc = this.dataHandle(val.desc);
          });
          console.log(classDate, 56987);
          this.listData = classDate;
          if (
            this.baseData.ui_teachers &&
            this.baseData.ui_teachers.length > 0
          ) {
            this.teachersList = this.baseData.ui_teachers;
            this.teachersInfo = this.baseData.ui_teachers[0];
          }
        })
        .catch((err) => {
          console.log("设计详情数据请求报错：", err);
        });
    },
    showBigImghandle(val) {
      this.biggerImgPreview = true;
      this.showBigImageUrl = val;
    },
    // 播放视频
    handleVideo(url,e) {
      this.baseInfo.pVideoUrl = url
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      this.$refs.editMenu.dialogFormV(this.baseInfo);
    },
    qimoChatClick(name) {
      this.$trackEvent(name, "点击图标", name);
      window.qimoChatClick();
    },
    // 学员作品信息展示切换
    statentsShowHandle(index) {
      this.studentsInfo = this.production.titleAndUrlImage[index];
    },
    // 讲师作品信息展示切换
    teachShowHandle(index) {
      this.teachersInfo = this.teachersList[index];
    },
    //课程列表数据处理
    dataHandle(data) {
      if (typeof data == "string" && data != "") {
        let items = data.split(/;|；/);
        let cont = items.map((val) => {
          let arr = val.split("：");
          if (arr[0].replace(/\t|\n|\s*/g, "") !== "") {
            return {
              title: arr[0].replace(/\t|\n|\s*/g, ""),
              conten: arr[1]
                .replace(/(^\s*)|(\s*$)/g, "")
                .split(/↵|\|\r|\n|\r\n/),
            };
          }
        });

        return cont;
      } else {
        return data;
      }
    },
    // bannber 数字跳转
    dataCount(obj, num, end, time, ind) {
      const i = ind ? ind : 1;
      this.timerNum[obj] = setInterval(() => {
        if (num < end) {
          num += i;
        } else if (num == end) {
          clearInterval(this.timerNum[obj]);
        }
        this[obj] = num;
      }, time);
    },
    liebiao(list) {
      let listDes = [];
      let listDesObj = {};
      list.ttitleAndDesc.forEach((val) => {
        listDesObj = {
          desc: val.desc.replace(/\n/g, ",").split(","),
          title: val.title,
          url: val.url,
        };
        listDes.push(listDesObj);
      });
      return listDes;
    },
    getFlowData(data) {
      this.itemAdvantage = data.UiModuleA[1];
      // 适合学员
      this.suitableStudents = data.UiModuleA[4];
      let listData = [];
      let listObj = {};
      data.SkillModules[0].ttitleAndDesc.forEach((val, i) => {
        listObj = {
          desc: val.desc.replace(/\n/g, ","),
          title: val.title,
          name: "active" + i,
        };
        listData.push(listObj);
      });
      data.SkillModules[0].ttitleAndDesc = listData;
      this.technology = data.SkillModules[0];
      data.SkillModules[1].ttitleAndDesc = this.liebiao(data.SkillModules[1]);
      this.framework = data.SkillModules[1];
      // 学习路线
      this.learning = data.UiModuleA[2];
      this.production = data.UiModuleB[0];
      this.studentsInfo = data.UiModuleB[0].titleAndUrlImage[0];
      console.log(this.production, 1125);
      // 师资力量
      this.strength = data.UiModuleA[3];
    },
    handleClick(val) {
      this.$trackEvent(
        this.listData[val.index].name,
        "点击",
        this.listData[val.index].name
      );
    },
    lookBigImage(url) {
      this.biggerImgPreview = true;
      this.showBigImageUrl = url;
    },
    closeImg() {
      console.log(333);
      this.biggerImgPreview = false;
      this.showBigImageUrl = "";
    },
  },
};
</script>
<style src="./scss/style.scss" rel="stylesheet/scss" lang="scss"></style>
<style lang="scss">
.bigImgDialog .el-dialog {
  width: 80% !important;
  max-width: 1180px;
}
.DesClose {
  cursor: pointer;
  position: absolute;
  top: 0px;
  right: -54px;
}
.el-dialog__body {
  position: relative;
}
</style>
